module.exports = __webpack_public_path__ + "static/media/dp-otw.9edb6b95.png";